import SearchPage from './SearchPage';
import SearchPageContainer from './SearchPage.container';

export default SearchPageContainer(SearchPage);
